const getFieldAddressAfterIndex = (address, index) => {
  // Match everything after the nth [] based on index
  const parts = address.split(/\[\]/); // Split by []

  if (index >= parts.length - 1) {
    return ""; // If index is out of bounds
  }

  // Join the remaining parts starting from the specified index
  const result = parts.slice(index + 1).join("[]");

  return result || ""; // Return null if nothing is found
};

export default getFieldAddressAfterIndex;
